import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-left">
            <div className="footer-brand">Dstribute</div>
            <div className="footer-location">📍 San Francisco, CA</div>
          </div>

          <div className="footer-center">
            <div className="footer-copyright">
              © 2025 Dstribute. All rights reserved.
            </div>
          </div>

          <div className="footer-right">
            <Link to="/privacy-policy" className="footer-link">
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;